import { render } from "./drop-items.vue?vue&type=template&id=a3d462aa&scoped=true"
import script from "./drop-items.vue?vue&type=script&lang=js"
export * from "./drop-items.vue?vue&type=script&lang=js"

import "./drop-items.vue?vue&type=style&index=0&id=a3d462aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d462aa"]])

export default __exports__